import React from 'react'
import { observer } from 'mobx-react-lite'
import { useStore } from '@store/StoreProvider'
import { t } from '@store/I18nStore'

/** Site-wide banner above header when browser network is offline. */
export const SiteWsConnectionBanner: React.FC = observer(() => {
  const { ui } = useStore()
  const kind = ui.wsSiteConnectionBannerKind

  if (kind === 'hidden') {
    return null
  }

  const isProblem = kind === 'problem'
  const text = isProblem ? t('app.connection.lost') : t('app.connection.restored')
  const palette = isProblem
    ? 'border-rose-400/40 bg-rose-100 text-rose-800'
    : 'border-emerald-400/40 bg-emerald-100 text-emerald-800'

  return (
    <div
      className={`fixed left-0 right-0 top-0 z-[60] w-full border-b px-4 py-2.5 text-center text-sm font-semibold shadow-sm ${palette}`}
      role={isProblem ? 'alert' : 'status'}
      aria-live={isProblem ? 'assertive' : 'polite'}>
      <span className="inline-flex items-center gap-2">
        {isProblem && (
          <span
            className="h-3.5 w-3.5 animate-spin rounded-full border-2 border-current border-r-transparent"
            aria-hidden="true"
          />
        )}
        {text}
      </span>
    </div>
  )
})
